<template>
  <!-- eslint-disable vue/no-v-html -->
  <svg
    :width="size"
    :height="size"
    :viewBox="def.viewBox"
    fill="none"
    :stroke="strokeColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :aria-hidden="isDecorative ? 'true' : undefined"
    :aria-label="isDecorative ? undefined : label"
    :role="isDecorative ? undefined : 'img'"
    class="inline-block shrink-0"
    v-html="def.body"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getIcon, type IconName } from '@/components/base/icons';

type IconSize = 12 | 14 | 16 | 18 | 20 | 24 | 28;

interface Props {
  name: IconName;
  size?: IconSize;
  label?: string;
  strokeWidth?: number;
  strokeColor?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 20,
  label: '',
  strokeWidth: 2,
  strokeColor: 'currentColor',
});

const def = computed(() => getIcon(props.name));
const isDecorative = computed(() => !props.label);
</script>
